import type { FaireProductEntity } from "../../entity_types/product";

export const p_46ugzthp9q: FaireProductEntity = {
  token: "p_46ugzthp9q",
  type: "product",
  name: "Sunset Wave Design T-Shirt Bella Canvas",
  brandToken: "b_uyrp83b3tq",
  brandName: "Soleinspire",
  imageUrl:
    "https://cdn.faire.com/fastly/e713d7f29346c50446eabc2156ec01c49c9c881c086dc7f29275825e388c08f6.webp",
  galleryImageUrls: [],
  priceDollars: 14.55,
  description:
    "The Bella Canvas 3001 tee offers unmatched comfort with its soft, lightweight fabric. Perfect for all-day wear, it features a modern fit and a stylish sunset wave design that adds a touch of nature-inspired elegance.\n\nsunset t-shirt, wave design tee, nature graphic tee, beach vibes shirt, sun and waves, minimalist t-shirt, artistic graphic tee, boho chic tee, summer style shirt, casual fashion, trendy ladies t-shirt, soft cotton tee, Bella Canvas 3001, modern fit t-shirt, aesthetic design shirt, nature lover tee, women's casual wear, graphic art t-shirt, stylish ladies teeCrafted with high-quality cotton, our Bella Canvas 3001 t-shirts offer exceptional comfort and durability in every size from XS to 3XL.",
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:45.103Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
